/**
 * Things built on the coach side that wait on something on the player side.
 *
 * A field the coach fills in for a player who cannot see it is worse than
 * no field: they write the note, the player never mentions it, and the
 * coach concludes the app is broken. Hiding the input leaves everything
 * already written exactly where it is — nothing is deleted, the coach can
 * still read it, and the API still stores and returns it.
 */

/**
 * The player's own view of what their coach wrote for them: the note on
 * each session and the homework. On since the player's Journal shipped,
 * which is where they read both.
 */
export const PLAYER_SEES_SHARED_NOTES = true;
